var map = {
	"./copies/da_DK.json": 98,
	"./copies/de_DE.json": 87,
	"./copies/en_GB.json": 382,
	"./copies/en_US.json": 531,
	"./copies/es_ES.json": 179,
	"./copies/fr_FR.json": 310,
	"./copies/lt.json": 307,
	"./copies/nl_NL.json": 542,
	"./copies/pt_PT.json": 791,
	"./copies/sv_SE.json": 349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 766;